export default class facetToggle {
  constructor(element) {
    let targetSelector = element.getAttribute("data-target");
    let toggleClassName = element.getAttribute("data-toggle-class");
    let toggleBtnClassName = element.getAttribute("data-toggle-btn");
    let target = element.getElementsByClassName(targetSelector)[0];
    let toggleBtn = element.getElementsByClassName(toggleBtnClassName)[0];

    if (!target || !toggleBtn) {
      return;
    }

    toggleBtn.addEventListener("click", function (e) {
      if (!target.classList.contains(toggleClassName)) {
        target.classList.add(toggleClassName);
        this.removeAttribute("aria-hidden");
        this.classList.remove("facet__toggle-btn--expand");
      } else {
        target.classList.remove(toggleClassName);
        this.setAttribute("aria-hidden", true);
        this.classList.add("facet__toggle-btn--expand");
      }
    });
  }
}
